
// import React, { useEffect, useState } from 'react';
// import LandscapeIcon from '../imagesicons/Group1.png';
// import CameraModule2 from './Camera2';
// import { Navigate, useParams } from 'react-router-dom';
// function LandscapeMode() {
//   const [isLandscape, setIsLandscape] = useState(false);
//   useEffect(() => {
//     const checkOrientation = () => {
//       // Treat as landscape when width > height or media query matches
//       const landscape =
//         window.matchMedia &&
//         window.matchMedia('(orientation: landscape)').matches
//           ? true
//           : window.innerWidth > window.innerHeight;

//       setIsLandscape(landscape);
//     };

//     checkOrientation();

//     window.addEventListener('resize', checkOrientation);
//     window.addEventListener('orientationchange', checkOrientation);

//     return () => {
//       window.removeEventListener('resize', checkOrientation);
//       window.removeEventListener('orientationchange', checkOrientation);
//     };
//   }, []);
// const { audit_id, auditID } = useParams();
// const id = audit_id || auditID;
//   if (isLandscape) {
//     // In landscape mode, show the actual camera screen (child component)
//   return <Navigate to={`/claim/camera/${id}`} replace />;
//     return null;
//   }

//   // In portrait mode, keep showing the "rotate phone" message
//   return (
//     <div>
//     <div className="landscape-container">
//       <div className="landscape-content">
//         <img
//           src={LandscapeIcon}
//           alt="landscape icon"
//           className="landscape-icon"
//         />
       
//       </div>
//       <h4 className="landscape-text">
//           Please rotate phone
//           <br />
//           to landscape
//         </h4></div>
//       <style jsx>{`
//         .landscape-container {
//   display: flex;
//   flex-direction: column;   /* stack circle and text vertically */
//   align-items: center;      /* center horizontally */
//   justify-content: center;  /* center whole content vertically */
//   height: 100vh;
//   width: 100vw;
//   background-color: white;
//   position: fixed;
//   top: 0;
//   left: 0;
//   z-index: 1000;
//   font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
//     Oxygen, Ubuntu, sans-serif;
//   gap: 20px; /* space between circle and text */
// }

// .landscape-content {
//   width: min(80vw, 250px);
//   aspect-ratio: 1 / 1;  
//   background-color: var(--Grays-Gray-6, #F2F2F7);
//   border-radius: 50%; 
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
// }

// .landscape-icon {
//   width: 100px;
//   height: 100px;
//   animation: rotate 2s ease-in-out infinite;
// }

// .landscape-text {
//   font-family: 'Barlow Condensed', sans-serif;
//   font-weight: 600;
//   font-size: 30px;
//   line-height: 124%;
//   letter-spacing: 0.25px;
//   text-align: center;
//   color: #2c3e50;
// }



//         .landscape-footer {
//           font-size: 16px;
//           color: #7f8c8d;
//           margin-top: 20px;
//           padding-top: 20px;
//           border-top: 1px solid #ecf0f1;
//           width: 100%;
//         }

//         @keyframes rotate {
//           0% {
//             transform: rotate(0deg);
//           }
//           25% {
//             transform: rotate(-15deg);
//           }
//           75% {
//             transform: rotate(15deg);
//           }
//           100% {
//             transform: rotate(0deg);
//           }
//         }

//         /* Responsive styles */
//         @media (max-width: 480px) {
//           .landscape-content {
//             padding: 30px 20px;
//             gap: 15px;
//           }

//           .landscape-icon {
//             width: 80px;
//             height: 80px;
//           }

//           .landscape-text {
//             font-size: 22px;
//           }

//           .landscape-footer {
//             font-size: 14px;
//           }
//         }

//         @media (max-width: 320px) {
//           .landscape-text {
//             font-size: 20px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// }

// export default LandscapeMode;
import React, { useEffect, useState } from "react";
import LandscapeIcon from "../imagesicons/Group1.png";
import { Navigate, useParams } from "react-router-dom";
import "./LandscapeMode.css";

function LandscapeMode() {
  const [isLandscape, setIsLandscape] = useState(false);
  const { audit_id } = useParams();
  const id = audit_id;

  useEffect(() => {
    const checkOrientation = () => {
      const landscape =
        window.matchMedia &&
        window.matchMedia("(orientation: landscape)").matches
          ? true
          : window.innerWidth > window.innerHeight;

      setIsLandscape(landscape);
    };

    checkOrientation();

    window.addEventListener("resize", checkOrientation);
    window.addEventListener("orientationchange", checkOrientation);

    return () => {
      window.removeEventListener("resize", checkOrientation);
      window.removeEventListener("orientationchange", checkOrientation);
    };
  }, []);

  if (isLandscape) {
    return <Navigate to={`/claim/camera/${id}`} replace />;
  }

  return (
    
      <div className="landscape-container">
        <div className="landscape-content">
          <img
            src={LandscapeIcon}
            alt="landscape icon"
            className="landscape-icon"
          />
        </div>

        <h4 className="landscape-text">
          Please rotate phone
          <br />
          to landscape
        </h4>
      </div>

     
  
  );
}

export default LandscapeMode;
